var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSoundoff = function SvgIcSoundoff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 1C4.8.5 4.1.5 3.6.9c-.5.3-.5 1-.2 1.5l3.3 4.1-.3.3c-.3.1-.4.4-.4.6v9.2c0 .3.1.5.4.6l6.5 4.1c.5.3 1.1 0 1.1-.6v-5.1l6 7.5c.2.3.5.4.9.4.2 0 .5-.1.7-.2.5-.4.5-1.1.2-1.5L5.1 1zM3.3 7H.7c-.4 0-.7.3-.7.7v8.5c0 .5.3.8.7.8h2.5c.5 0 .8-.3.8-.7V7.7c0-.4-.3-.7-.7-.7zM14 3.3c0-.6-.6-.9-1.1-.6l-2.4 1.5L14 8.6V3.3zM17.5 12c0 .3 0 .6-.1.9l1.7 2.1c.4-.9.7-1.9.7-3 0-1.8-.7-3.5-1.8-4.8-.3-.3-.8-.4-1.1-.1l-.5.5c-.3.3-.3.7-.1 1 .8 1 1.2 2.1 1.2 3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 12c0 1.7-.5 3.2-1.3 4.6l1.4 1.8c1.3-1.9 2.1-4 2.1-6.4 0-3-1.2-5.7-3.2-7.7-.3-.3-.8-.3-1.1 0l-.5.5c-.3.3-.3.7 0 1 1.6 1.7 2.6 3.8 2.6 6.2z"
  })));
};
export default SvgIcSoundoff;